module.exports = __webpack_public_path__ + "img/title-en.decc76d8.png";